// dependencies.
import { get } from 'lodash'

const REGISTER_TO_PATIENT = get(process.env, 'REGISTER_TO_PATIENT')

/**
 * detect the api base URL
 */
export default REGISTER_TO_PATIENT



// WEBPACK FOOTER //
// ./src/plugins/http/patient-register.js